import { render } from "./_id.vue?vue&type=template&id=ad2cbcd0&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=ad2cbcd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad2cbcd0"

export default script